import { Features, UserRole } from "../Enums/companyStatus";
import { enqueueSnackbar } from "notistack";

const getTokenPayload = (): any | null => {
  const token = localStorage.getItem("cih_token");
  if (!token) return null;

  try {
    const payloadBase64 = token.split(".")[1];
    return JSON.parse(atob(payloadBase64));
  } catch {
    enqueueSnackbar("Error decoding token", { variant: "error" });
    return null;
  }
};

export const getCurrentUserId = (): number | null => {
  const payload = getTokenPayload();
  if (!payload?.sub) return null;

  const userId = Number(payload.sub);
  return Number.isNaN(userId) ? null : userId;
};

export const hasPermission = (feature: Features): boolean => {
  const payload = getTokenPayload();
  if (!payload) return false;
  const permissions: Features[] = payload.permissions || [];
  return permissions.includes(feature);
};

export const hasRole = (role: UserRole): boolean => {
  const payload = getTokenPayload();
  if (!payload) return false;
  const userRole: UserRole = payload.role || null;
  return userRole === role;
};

export const userRoleToString = (role: UserRole | number): string => {
  switch (role) {
    case UserRole.USER:
      return "profile.roleUser";
    case UserRole.ADMIN:
      return "profile.roleAdmin";
    default:
      return "profile.roleUnknown";
  }
};
